import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

export class SvgSchemaPlugin extends SchemaPlugin {
  nodes = {
    svg: {
      group: 'inline',
      inline: true,
      atom: true,
      attrs: {
        content: { default: undefined, skipExport: true, skipEditorExport: true }
      },
      parseDOM: [{
        tag: 'svg',
        getAttrs: function (dom: HTMLElement) {
          return {
            content: dom.outerHTML
          };
        }
      }],
      // Render the SVG content directly in the editor
      toDOM(node) {
        const outputSpec = nodeToDOM(node, { isVoid: true });
        outputSpec.dom.innerHTML = node.attrs.content ?? '';
        return outputSpec;
      },
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        return nodeToFlareXML(node, options, 'svg', {
          xml: node.attrs.content
        });
      }
    }
  } satisfies Record<string, NodeSpec>;
}
